import {
  DataGovernance,
  LogLevel,
  PollingMode,
  createConsoleLogger,
  getClient,
} from 'configcat-js';

const logger = createConsoleLogger(
  process.env.NODE_ENV !== 'development' ? LogLevel.Warn : LogLevel.Info
);

export const temporaryClient = getClient(
  process.env.EXPO_PUBLIC_CONFIGCAT_TEMPORARY_CONFIG || 'DUMMY_KEY',
  PollingMode.ManualPoll,
  {
    logger,
    dataGovernance: DataGovernance.EuOnly,
  }
);

export const permanentClient = getClient(
  process.env.EXPO_PUBLIC_CONFIGCAT_PERMANENT_CONFIG || 'DUMMY_KEY',
  PollingMode.ManualPoll,
  {
    logger,
    dataGovernance: DataGovernance.EuOnly,
  }
);
